import moment from 'moment'
import numeral from 'numeral'

export const Invoice = {
  id: '',
  invoiceNo: '',
  date: '',
  patientId: '',
  patientName: '',
  patientQq: '',
  paymentMethod: '',
  paymentMethodRemarks: '',
  isPaid: '',
}

export const InvoiceDetail = {
  id: '',
  medicalRecordId: '',
  date: moment().format('YYYY-MM-DD'),
  teeth: '',
  description: '',
  percent: 0,
  totalAfterPercent: 0,
  isPayable: false,
  discount: 0,
  treatmentId: '',
  treatmentName: '',
}